import { Coordinates } from "@evergis/sgis/es/baseTypes";
import { Crs } from "@evergis/sgis/es/Crs";
import { PointFeature } from "@evergis/sgis/es/features/PointFeature";
import { ShadowedPointSymbol } from "../../../../../../react-sgis/symbols/editorSymbols/ShadowedPointSymbol";

export const createPointFeature = (position: Coordinates, crs: Crs, symbol: ShadowedPointSymbol): PointFeature => {
  const feature: PointFeature = new PointFeature(position, { crs });

  feature.symbol = symbol;

  return feature;
};
